import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
// import { FoodListPage } from '../menu/food-list/food-list.page';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AppButtonComponent } from '../components/app-button/app-button.component';
import { MySubscriptionCardComponent } from '../components/my-subscription-card/my-subscription-card.component';
import { MyCardComponent } from '../components/my-card/my-card.component';
import { MenuItemComponent } from '../components/menu-item/menu-item.component';
import { MacrosBarComponent } from '../components/marcos-bar/macros-bar.component';
import { TabBarComponent } from '../components/tab-bar/tab-bar.component';
import { CommentModalPage } from '../community/comment-modal/comment-modal.page';
import { PostModalPage } from '../community/post-modal/post-modal.page';
import { PopupModalComponent } from '../components/popup-modal/popup-modal.component';
import { AppSliderComponent } from '../components/app-slider/app-slider.component';
import { AreaListsPage } from '../pages/area-lists/area-lists.page';
import { TermsAndConditionsPage } from '../pages/terms-and-conditions/terms-and-conditions.page';
import { MenuDetailPage } from '../menu/menu-detail/menu-detail.page';
import { CustomLoaderComponent } from '../components/custom-loader/custom-loader.component';
import { EditAddressPage } from '../pages/edit-address/edit-address.page';
import { RatingComponentForm } from '../calendar/rating/component/rating-form.component';
import { RatingPage } from '../calendar/rating/rating.page';
import { SelectionPage } from '../calendar/selection/selection.page';
import { AppStatComponent } from '../components/app-stat/app-stat.component';
import { RewardItemComponent } from '../components/reward-item/reward-item.component';
import { AppRatingComponent } from '../components/app-rating/app-rating.component';
import { AppInputComponent } from '../components/app-input/app-input.component';
import { AppHeaderComponent } from '../components/app-header/app-header.component';
import { AnimatedCounterComponent } from '../components/animated-counter/animated-counter.component';
import { AboutusPage } from '../pages/aboutus/aboutus.page';
import { GeneralModalComponent } from '../components/general-modal/general-modal.component';
import { MealPreferencePage } from '../calendar/meal-preference/meal-preference.page';
import { AllergyConfirmationModalComponent } from '../components/allergy-confirmation-modal/allergy-confirmation-modal.component';
import { SignUpComponent } from '../components/signup-form/signup.component';
import { SignInComponent } from '../components/signin-form/signin.component';
import { SlideBarComponent } from '../components/slide-bar/slide-bar.component';
import { CustomizationModalPage } from '../menu/customization-modal/customization-modal.page';

@NgModule({
  declarations: [
    SlideBarComponent,
    MyCardComponent,
    MealPreferencePage,
    GeneralModalComponent,
    AboutusPage,
    AnimatedCounterComponent,
    MySubscriptionCardComponent,
    MenuDetailPage,
    AppHeaderComponent,
    RatingComponentForm,
    RatingPage,
    SelectionPage,
    CommentModalPage,
    PostModalPage,
    EditAddressPage,
    AreaListsPage,
    TermsAndConditionsPage,
    AppInputComponent,
    AppRatingComponent,
    AppStatComponent,
    PopupModalComponent,
    RewardItemComponent,
    CustomLoaderComponent,
    AppSliderComponent,
    PopupModalComponent,
    TabBarComponent,
    AppButtonComponent,
    MySubscriptionCardComponent,
    MenuItemComponent,
    MacrosBarComponent,
    AllergyConfirmationModalComponent,
    SignUpComponent,
    SignInComponent,
    CustomizationModalPage
  ],
  imports: [CommonModule, IonicModule, FormsModule, TranslateModule, ReactiveFormsModule],
  exports: [
    SlideBarComponent,
    CustomizationModalPage,
    MyCardComponent,
        SignUpComponent,
    SignInComponent,
    GeneralModalComponent,
    MealPreferencePage,
    AboutusPage,
    AnimatedCounterComponent,
    MySubscriptionCardComponent,
    MenuDetailPage,
    AppHeaderComponent,
    RatingComponentForm,
    RatingPage,
    SelectionPage,
    CommentModalPage,
    PostModalPage,
    EditAddressPage,
    AreaListsPage,
    TermsAndConditionsPage,
    AppInputComponent,
    AppRatingComponent,
    AppStatComponent,
    PopupModalComponent,
    RewardItemComponent,
    CustomLoaderComponent,
    AppSliderComponent,
    PopupModalComponent,
    TabBarComponent,
    AppButtonComponent,
    MySubscriptionCardComponent,
    MenuItemComponent,
    MacrosBarComponent,
    AllergyConfirmationModalComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
